import styled from 'styled-components';
import ScIconWrapper from '../../sc/ScIconWrapper';

const ScFullScreenButton = styled(ScIconWrapper)`
  width: 22px;
  height: 22px;
`;

export default ScFullScreenButton;
